// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"EditUserModal-m__checkboxContainer___3H_5l"};